import { render, staticRenderFns } from "./Suspension.vue?vue&type=template&id=8b8acbc6&scoped=true&"
import script from "./Suspension.vue?vue&type=script&lang=js&"
export * from "./Suspension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8acbc6",
  null
  
)

export default component.exports